const formatText = (string, capitalize) => {
  let str = string.replace('_', ' ');
  if (capitalize) {
    str = str.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
  } else {
    return str;
  }
};

const truncate = (str) => {
  return str.length > 250 ? str.substring(0, 250).trim() + '...' : str;
};

const convertCsvDataToJson = (results) => {
  const values = results.data;
  const headers = values[0];

  let data = values.map((d, i) => {
    if (i > 0) {
      const obj = {};
      d.map((value, j) => {
        obj[headers[j]] = value;
      });
      return obj;
    }
  });
  data.shift();

  console.log('CSV HEADERS', headers);
  console.log('CSV DATA', data);
  return data;
};

const formatData = (data, stance) => {
  if (!data) return;
  return data.map((d) => {
    // Format color
    d.color = findIdeologyColor(d.ideology_value);
    // Format size
    d.traffic = d.traffic.replace(',', '.');
    if (d.traffic.includes('M')) {
      d.size = parseFloat(d.traffic.replace('M', '')) * 1000000;
    } else if (d.traffic.includes('K')) {
      d.size = parseFloat(d.traffic.replace('K', '')) * 1000;
    } else {
      d.size = parseFloat(d.traffic);
    }
    d.year = parseFloat(d.age_value);
    // Format x
    d.x = parseFloat(d.ideology_value) + randomNumber(d.ideology_value);
    // Format y
    const stance_key =
      stance === '0' ? 'no_stance_score' : 'stance_' + stance + '_score';
    d.y = parseFloat(d[stance_key]);
    return d;
  });
};

const randomNumber = (ideology) => {
  const min = -0.1;
  const max = 0.1;
  if (ideology === '-1.0') {
    return Math.random() * (max - 0) + 0;
  } else if (ideology === '1.0') {
    return Math.random() * (0 - min) + min;
  } else {
    return Math.random() * (max - min) + min;
  }
};

const findIdeologyColor = (ideology) => {
  switch (ideology) {
    case '-1.0':
      return 'maroon';
    case '-0.66':
      return 'red';
    case '-0.33':
      return 'orange';
    case '0.0':
      return 'green';
    case '0.33':
      return 'darkslategray';
    case '0.66':
      return 'blue';
    case '1.0':
      return 'navy';
    default:
      return 'gray';
  }
};

const findUniqueValues = (key, data) => {
  const uniqueValues = data
    .map((item) => item[key])
    .filter(
      (value, index, current_value) =>
        current_value.indexOf(value) === index && value
    );
  console.log('UNIQUE VALUES', key, ' -> ', uniqueValues);
  return uniqueValues;
};

export {
  formatText,
  truncate,
  convertCsvDataToJson,
  formatData,
  findUniqueValues,
};
